import { Tag } from 'antd';
import { isForeignAuthorFeatureEnabled } from 'constant';

/**
 * @description Yabancı yazar rozeti: yazar yabancı işaretliyse altın renkli bir Tag basar,
 * değilse hiçbir şey render etmez (boş Tag veya fazladan boşluk bırakmaz). Özellik bayrağı
 * (`REACT_APP_FEATURE_FOREIGN_AUTHOR`) kapalıyken `isForeign` ne olursa olsun rozet basılmaz.
 * Yazar adının geçtiği ekranlarda, maddenin yabancı yazarlı sürece girdiğini gösterir.
 *
 * Renk antd preset paletinden `gold`; mavi heyet kısaltmasına, yeşil "Yazar" rolüne,
 * kırmızı ise medya teklifindeki "Uygun Değildir" kararına ayrılmış durumda.
 *
 * @param {Object} props
 * @param {boolean} [props.isForeign=false] Yazar kaydındaki `isForeign` bayrağı; false/undefined ise rozet basılmaz.
 * @param {string} [props.label='Yabancı Yazar'] Rozet metni; yazar yerine süreci anlatan bağlamlarda değiştirilir.
 * @param {string} [props.className=''] Çağrı noktasının boşluk/hizalama sınıfları (ör. `gx-ml-1`).
 * @param {Object} [props.style] Tag'in kendi stilini ezmek için (ör. virgülle biten listede sağ boşluğu kapatmak).
 */
function ForeignAuthorTag({ isForeign = false, label = 'Yabancı Yazar', className = '', style }) {
  if (!isForeignAuthorFeatureEnabled || !isForeign) return null;
  return (
    <Tag
      color="gold"
      className={className}
      style={style}
    >
      {label}
    </Tag>
  );
}

export default ForeignAuthorTag;
